import axios from 'axios'

/**
 * Custom function to allow parameter serialization as expected from the backend.
 * Its main purpose is to turn array of parameters into repeated url keys.
 *
 * Example:
 * a: [1, 2] => &a=1,2
 *
 * @param   {object} params
 *
 * @returns {string}
 */
const getParametersSerialized = params => {
  let options = ''

  Object.keys(params).forEach(key => {
    const paramValue = params[key]
    const isParameterTypeObject = typeof paramValue === 'object'

    if (paramValue) {
      if (isParameterTypeObject && paramValue.length) {
        options = `${options}${key}=${encodeURIComponent(
          paramValue.join(',')
        )}&`
      } else if (!isParameterTypeObject) {
        options = `${options}${key}=${encodeURIComponent(paramValue)}&`
      } else {
        console.warn(
          `Parameter "${key}" is of type "${typeof paramValue}" and will be ignored.`
        )
      }
    }
  })

  return options ? options.slice(0, -1) : options
}

/**
 * @param   {string} apiBaseUrl
 *
 * @returns {object}            AxiosInstance
 */
const initializeAxios = apiBaseUrl => {
  return axios.create({
    baseURL: apiBaseUrl,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Stitch-Client': 'Boards-FE'
    },
    withCredentials: true,
    paramsSerializer: params => getParametersSerialized(params)
  })
}

export { getParametersSerialized, initializeAxios }
